import Database from 'database';

export const Types = {
  GET_CIDADES: 'cidades/GET_CIDADES',
  GET_CIDADES_SUCCESS: 'cidades/GET_CIDADES_SUCCESS',
  GET_CIDADES_FAILED: 'cidades/GET_CIDADES_FAILED',
};

/**
 * @type {{
  loading: boolean,
  error: string | null,
  data: Cidade[],
}}
 */
const initialState = {
  loading: false,
  error: null,
  data: [],
};

export default function cidadesReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_CIDADES:
      return { ...state, loading: true };
    case Types.GET_CIDADES_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.GET_CIDADES_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}

export const Creators = {
  getCidades: condition => async dispatch => {
    try {
      dispatch({ type: Types.GET_CIDADES });
      const cidades = await Database.cidades
        .filter(condition || (() => false))
        .toArray();
      dispatch({ type: Types.GET_CIDADES_SUCCESS, payload: { data: cidades } });
    } catch (woof) {
      console.error(woof.message);
      dispatch({
        type: Types.GET_CIDADES_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
};
